module.exports = __webpack_public_path__ + "static/Cronometro-Black-Desktop-03c1b469603708e2aba09f2e58e3a752.png";